/* unplugin-vue-components disabled */import { render } from "./HeaderCustom.vue?vue&type=template&id=a6e17254&scoped=true"
import script from "./HeaderCustom.vue?vue&type=script&lang=js"
export * from "./HeaderCustom.vue?vue&type=script&lang=js"

import "./HeaderCustom.vue?vue&type=style&index=0&id=a6e17254&scoped=true&lang=css"

import exportComponent from "D:\\00JH-项目\\钧舵机器人\\en\\jodell_robotics\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e17254"]])

export default __exports__